
<div style="position: relative;">
  <div (click)="showRoles=!showRoles" style="cursor: pointer;" type="button" data-toggle="dropdown"><span class="oi oi-person"></span><span style="margin: 0px 8px;">{{ text }} </span>
    <div class="dropdown-menu dropdown-menu-left" *ngIf="showRoles" style="position: absolute; left: -2rem; padding: 8px; display: block;">
      <ul style="padding-left: 32px;">
        <li *ngFor="let role of roles">{{ role.name }}  </li>
      </ul>
    </div>
  </div>
</div>